(() => {
  const source=document.currentScript?.dataset.familiesUrl;
  if(!source)return;
  let registry;
  const load=()=>registry ||= fetch(source).then(r=>{if(!r.ok)throw Error('Colour registry unavailable');return r.json();});
  if(customElements.get('z-colour-family'))return;
  customElements.define('z-colour-family',class extends HTMLElement {
    connectedCallback(){
      this.events?.abort();this.events=new AbortController();
      this.addEventListener('click',event=>{
        const control=event.target.closest('[data-z-colour-option]');
        if(!control||!this.contains(control))return;
        event.preventDefault();event.stopPropagation();
        this.select(this.entries?.[Number(control.dataset.zColourOption)],control);
      },{signal:this.events.signal});
      if(typeof subscribe==='function')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data}={})=>{
        const info=this.closest('product-info');
        if(!info||data?.sectionId!==info.sectionId)return;
        const colour=info.querySelector('[data-zico-color-option-group] input:checked')?.value;
        const entry=this.entries?.find(e=>e.handle===this.dataset.handle&&(String(e.variant)===String(data.variant?.id)||e.color===colour));
        if(entry)this.setSelection(entry,data.variant?.id);
        this.releaseSubmitBlocking();
        this.removeAttribute('aria-busy');
      });
      this.renderPromise=this.render();
    }
    disconnectedCallback(){this.events?.abort();this.unsubscribe?.();}
    releaseSubmitBlocking(restoreDisabled=false){
      const state=this.submitSnapshot;if(!state)return;
      if(restoreDisabled)state.submit.disabled=state.disabled;
      state.aria===null?state.submit.removeAttribute('aria-disabled'):state.submit.setAttribute('aria-disabled',state.aria);
      this.submitSnapshot=null;
    }
    setSelection(entry,variant=entry.variant){
      this.dataset.handle=entry.handle;this.dataset.variant=variant;this.dataset.color=entry.color;
      this.querySelectorAll('[data-z-colour-option]').forEach(control=>{
        const item=this.entries[Number(control.dataset.zColourOption)];
        const active=item.handle===entry.handle&&item.color===entry.color;
        control.setAttribute('aria-pressed',String(active));
        if(active)control.setAttribute('aria-current','true');else control.removeAttribute('aria-current');
      });
      const value=this.querySelector('[data-selected-value]');if(value)value.textContent=entry.color;
      this._zCompactUpdate?.();
    }
    showError(){
      this.removeAttribute('aria-busy');
      let status=this.querySelector('[data-z-colour-error]');
      if(!status){status=document.createElement('p');status.className='z-colour-error';status.dataset.zColourError='';status.setAttribute('role','status');this.append(status);}
      status.textContent='Unable to change colour. Please try again.';
    }
    async select(entry,control){
      if(!entry)return;
      const ticket=this.selectionTicket=(this.selectionTicket||0)+1;
      this.querySelector('[data-z-colour-error]')?.remove();this.restorePreview?.();
      const info=this.closest('product-info');
      if(info)return this.selectProduct(info,entry,control);
      const card=this.closest('product-component,.zv7-card');if(!card)return;
      if(control.getAttribute('aria-pressed')==='true'&&!card.hasAttribute('aria-busy'))return;
      const target=new URL(entry.url,location.href);if(entry.variant)target.searchParams.set('variant',entry.variant);
      const next=await window.ZicoCardColours?.selectCard(card,control,target.href,{restorePreview:this.restorePreview});
      if(ticket!==this.selectionTicket)return;
      if(next&&this.isConnected)this.setSelection(entry);else if(!next&&this.isConnected)this.showError();
    }
    selectProduct(info,entry,control){
      const url=new URL(entry.url,location.href);
      if(url.origin!==location.origin||!/(?:^|\/)products\/[^/]+$/.test(url.pathname)){this.showError();return;}
      const root=window.Shopify?.routes?.root||'/';
      if(root!=='/'&&url.pathname.startsWith('/products/'))url.pathname=root.replace(/\/$/,'')+url.pathname;
      const sameProduct=info.dataset.url.split('/').pop()===entry.handle;
      const option=[...info.querySelectorAll('[data-zico-color-option-group] input')].find(e=>e.value===entry.color);
      const currentVariant=info.getSelectedVariant(info)?.id||info.querySelector('input[name="id"]')?.value||this.dataset.variant;
      // Native radios own pending intent; rendered variant and pressed state can lag behind it.
      if(sameProduct&&option&&!option.checked){option.click();return;}
      if(sameProduct&&(option?.checked||control.getAttribute('aria-pressed')==='true'||String(currentVariant)===String(entry.variant))){
        if(this.hasAttribute('aria-busy')){
          const prior=info.abortController;info.abortController=new AbortController();prior?.abort();
          info.pendingRequestUrl=null;this.releaseSubmitBlocking(true);this.removeAttribute('aria-busy');
        }
        this.setSelection(entry,currentVariant);return;
      }
      if(typeof info.renderProductInfo!=='function'){this.showError();return;}
      if(entry.variant)url.searchParams.set('variant',entry.variant);
      if(sameProduct)url.searchParams.set('section_id',info.sectionId);
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      const submit=info.querySelector('product-form button[type="submit"]');
      if(submit&&this.submitSnapshot?.submit!==submit)this.submitSnapshot={submit,disabled:submit.disabled,aria:submit.getAttribute('aria-disabled')};
      const priorSubmit=this.submitSnapshot;
      if(submit){submit.disabled=true;submit.setAttribute('aria-disabled','true');}
      this.setAttribute('aria-busy','true');let owner,failed=false;
      const fail=()=>{
        if(failed||!this.isConnected||info.abortController!==owner)return;
        failed=true;this.releaseSubmitBlocking(true);
        this.showError();
      };
      const pending=info.renderProductInfo({
        requestUrl:url.href,target:control,
        beforeCommit:async html=>{
          const next=html.querySelector('product-info');
          const variant=info.getSelectedVariant(next)?.id||next?.querySelector('input[name="id"]')?.value;
          if(!next||next.dataset.url.split('/').pop()!==entry.handle||entry.variant&&String(variant)!==String(entry.variant))throw new Error('Colour response did not match selection');
          const media=[...next.querySelectorAll('.product__media-list img,.z-gallery__slide img')].slice(0,2);
          await Promise.all(media.map(image=>window.ZicoCardColours.ready(image.getAttribute('src'))));
          if(!sameProduct){
            const form=next.querySelector('product-form[data-zico-requires-size="true"]');
            if(form){form.dataset.zicoSizeSelected='false';delete form.dataset.zicoSizeValueId;}
          }
        },
        callback:(html,request)=>{
          const ownsFocus=document.activeElement===control;
          const anchor=!sameProduct&&(ownsFocus||document.activeElement===document.body)?control.getBoundingClientRect():null;
          const nextId=html.querySelector('product-info')?.id;
          const title=html.querySelector('head title');if(!sameProduct&&title)document.title=title.textContent;
          const commit=sameProduct?info.handleUpdateProductInfo(url.pathname):info.handleSwapProduct(url.pathname,false);
          commit(html,request);
          if(!sameProduct)document.dispatchEvent(new CustomEvent('zico:product-colour-selected',{detail:{html}}));
          return Promise.resolve().then(async()=>{
            if(sameProduct&&this.isConnected){this.removeAttribute('aria-busy');this.submitSnapshot=null;this.setSelection(entry);}
            const next=[...document.querySelectorAll('product-info')].find(e=>e!==info&&e.id===nextId&&e.dataset.url.split('/').pop()===entry.handle);
            await next?.querySelector('z-colour-family')?.renderPromise;
            const target=[...next?.querySelectorAll('[data-z-colour-option]')||[]].find(e=>e.title===entry.color);
            if(ownsFocus&&(document.activeElement===document.body||document.activeElement===control)){
              target?.focus({preventScroll:true});
            }
            if(anchor&&anchor.top>=0&&anchor.bottom<=window.innerHeight&&target&&(document.activeElement===target||document.activeElement===document.body)){
              const delta=target.getBoundingClientRect().top-anchor.top;
              if(Math.abs(delta)>0.5)window.scrollBy({top:delta,behavior:'instant'});
            }
            return true;
          });
        },onError:fail,
      });
      owner=info.abortController;
      const timer=window.setTimeout(()=>{if(info.abortController===owner){owner.abort();fail();}},12000);
      pending.finally(()=>window.clearTimeout(timer));return pending;
    }
    async render(){
      if(!this.isConnected||this.dataset.ready)return;
      const legacy=this.dataset.surface==='product'&&this.closest('product-info')?.querySelector('.zico-ridar-family');
      if(legacy){
        const anchors=[...legacy.querySelectorAll('a.zico-ridar-family__option')];
        this.entries=anchors.map(a=>{
          const url=new URL(a.href,location.href);
          return{handle:url.pathname.split('/').pop(),variant:url.searchParams.get('variant'),color:a.title,url:url.href};
        });
        const selectedIndex=Math.max(0,anchors.findIndex(a=>a.hasAttribute('aria-current')));
        anchors.forEach((a,index)=>{
          const button=document.createElement('button');
          for(const attribute of a.attributes)if(attribute.name!=='href')button.setAttribute(attribute.name,attribute.value);
          button.type='button';button.dataset.zColourOption=index;button.append(...[...a.childNodes].map(n=>n.cloneNode(true)));a.replaceWith(button);
        });
        legacy.querySelector('legend span')?.setAttribute('data-selected-value','');
        this.append(legacy);this.dataset.ready='true';this.setSelection(this.entries[selectedIndex]);return;
      }
      let groups;
      try{groups=await load();}catch{return;}
      if(!this.isConnected||this.dataset.ready)return;
      const family=groups[this.dataset.handle];
      if(!family||family.length<2)return;
      this.entries=family;
      const links=document.createElement('div');links.className='z-colour-family__links';
      links.setAttribute('aria-label','Colours');
      const selected=family.find(e=>e.handle===this.dataset.handle&&String(e.variant)===this.dataset.variant)||family.find(e=>e.handle===this.dataset.handle&&e.color===this.dataset.color)||family.find(e=>e.handle===this.dataset.handle);
      for(const entry of family){
        const a=document.createElement('button');a.type='button';a.dataset.zColourOption=family.indexOf(entry);a.title=entry.color;a.setAttribute('aria-label',entry.color);a.setAttribute('aria-pressed',String(entry===selected));
        if(entry===selected)a.setAttribute('aria-current','true');
        if(entry.image){const image=document.createElement('img');const url=new URL(entry.image,location.href);url.searchParams.set('width','80');image.src=url.href;image.alt=entry.color;image.width=44;image.height=44;image.loading='lazy';a.append(image);}
        else{a.textContent=entry.color;a.style.borderRadius='0';a.style.width='auto';a.style.flexBasis='auto';}
        links.append(a);
      }
      if(this.dataset.surface==='product'){
        const label=document.createElement('div');label.className='form__label';
        label.append('Color: ');
        const value=document.createElement('span');value.dataset.selectedValue='';
        value.textContent=family.find(e=>e.handle===this.dataset.handle&&String(e.variant)===this.dataset.variant)?.color||family.find(e=>e.handle===this.dataset.handle)?.color||'';
        label.append(value);
        this.append(label);
      } else {
        const card=this.closest('product-component,.zv7-card');
        const image=card?.querySelector('.card__media .media > img,.zv7-card__primary');
        const secondary=card?.querySelector('.card__media .media > img:nth-child(2),.zv7-card__secondary');
        if(image){
          this.restorePreview=window.ZicoCardColours?.preview(card,image,secondary,[...links.children].map((control,i)=>({control,image:family[i].image})));
        }
      }
      this.append(links);this.dataset.ready='true';
      if(this.dataset.surface!=='product')window.ZicoCardColours?.compact(links,'[data-z-colour-option]');
    }
  });
})();
